const TruckLoadIcon = ({ color = '#000', width = 24 }) => {
    return (
        <svg 
            id="Layer_1" 
            data-name="Layer 1" 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 59.9 52" 
            width={width} 
            height={width} 
            style={{ verticalAlign: 'middle' }}
        >
            <path 
                fill={color}
                d="M59.3,37.3h-2.7c-1-.6-2.1-.9-3.5-1.1h6.2v-3.5h-28.7V3.9h28.7V.5H27.2v35.7h12.9v1.1h-4v4.9h.8l-7.9,1.7v-1.1h-1.7v4.2h1.7v-1.2l9.2-2.1h4.4v2.1h1.7c0,1.7.9,3.3,2.1,4.5,1.4,1.4,3.3,2.2,5.3,2.2s3.9-.9,5.2-2.2c1.1-1.2,1.9-2.7,2.1-4.5h.4v-8.5h0ZM51.6,48.7c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6,3.6,1.6,3.6,3.6-1.6,3.6-3.6,3.6Z"
            />
            <path 
                fill={color}
                d="M15.6,2.6v5.9H2.4c-1.1,0-2,.9-2,2s.9,2,2,2h13.3v5.9c0,1.2.7,1.5,1.5.6l8.4-8.6L17.2,1.8c-.8-.8-1.5-.6-1.5.6v.2s-.1,0-.1,0Z"
            />
            <path 
                fill={color}
                d="M15.6,23.6v5.9H2.4c-1.1,0-2,.9-2,2s.9,2,2,2h13.3v5.9c0,1.2.7,1.5,1.5.6l8.4-8.6-8.4-8.6c-.8-.8-1.5-.6-1.5.6v.2h-.1Z"
            />
        </svg>
    );
};

export default TruckLoadIcon;
